// extracted by mini-css-extract-plugin
module.exports = {"SampleSection":"__5-sample_SampleSection__D9t6J","SampleIntro":"__5-sample_SampleIntro__MnEst","imgWrap":"__5-sample_imgWrap__ilbyh","SampleLink":"__5-sample_SampleLink__Rx7Bq"};